import { useCallback } from "react"
import debounce from "lodash/debounce"
import { initialSearchState } from "../../components/search/searchModalContext"

const search = (client, query, filters) =>
  client
    .search(query, {
      hitsPerPage: 5,
      filters
    })
    .catch(e => console.error(e)) // eslint-disable-line no-console

const handleSearchInput = (client, setHits) => query => {
  if (query === "") {
    setHits(initialSearchState)
  } else {
    search(client, query, "collection:documentation").then(({ hits }) =>
      setHits(state => ({
        ...state,
        documentation: hits,
        documentationLoading: false
      }))
    )

    search(client, query, "collection:api-reference").then(({ hits }) =>
      setHits(state => ({
        ...state,
        apiReference: hits,
        apiReferenceLoading: false
      }))
    )
  }
}

export default (client, setHits, delay) =>
  useCallback(debounce(handleSearchInput(client, setHits), delay), [])
